export enum MenuCode {
  COP_1_1 = 'COP.1.1', // Cambiar Vehículo
  COP_1_2 = 'COP.1.2', // Cambiar Estado
  COP     = 'COP',     // Control Operaciones

  MAP     = 'MAP',     // Visor de Mapa

  MGT_1   = 'MGT.1',   // Análisis Gerencial
  NEW     = 'NEW',     // Nuevo Viaje
  HMP     = 'HMP',     // Mapa de Calor
  MGT_2   = 'MGT.2',   // Tablero Gerencial

  TRP     = 'TRP',     // Viajes
  TMU     = 'TMU',     // Carga Manifiesto
  RCR     = 'RCR',     // Viajes Recurrentes
  TMG     = 'TMG',     // Gestión de viajes
  QTS     = 'QTS',     // Cotizaciones
  TMG_2   = 'TMG.2',   // Activar/Desactivar Asig. Auto.
  TMG_1   = 'TMG.1',   // Editar Datos Finales

  CLI     = 'CLI',     // Clientes
  CLI_E   = 'CLI.E',   // Gestión empresas
  CLI_I   = 'CLI.I',   // Gestión Individuos
  CLI_E_1 = 'CLI.E.1', // Adm Cuenta Corriente
  CLI_I_1 = 'CLI.I.1', // Adm Cuenta Corriente

  CAJ_C   = 'CAJ.C',   // Cierres de Caja
  CAJ_R   = 'CAJ.R',   // Realizadas
  CAJ_P   = 'CAJ.P',   // Pendientes

  LIQ     = 'LIQ',     // Liquidaciones
  LIQ_O   = 'LIQ.O',   // Propietarios
  LIQ_D   = 'LIQ.D',   // Choferes
  LIQ_I   = 'LIQ.I',   // Individuos
  LIQ_E   = 'LIQ.E',   // Empresas

  CC      = 'CC',      // Cuentas Corrientes
  CC_M    = 'CC.M',    // MAGIIS
  CC_O    = 'CC.O',    // Propietarios
  CC_D    = 'CC.D',    // Choferes
  CC_C    = 'CC.C',    // Clientes

  VHC     = 'VHC',     // Vehículos
  VHC_1   = 'VHC.1',   // Gestión de Vehículos

  OWN     = 'OWN',     // Propietarios
  OWN_1   = 'OWN.1',   // Gestión de Propietarios

  DRV     = 'DRV',     // Choferes
  DRV_1   = 'DRV.1',   // Gestión de Choferes

  REP     = 'REP',     // Reportes
  REP_17  = 'REP.17',  // Impuestos y Cargos
  REP_16  = 'REP.16',  // Antigüedad de Deuda
  REP_15  = 'REP.15',  // Propinas
  REP_14  = 'REP.14',  // Movimientos de Pagos
  REP_13  = 'REP.13',  // Movimientos de Cobros
  REP_12  = 'REP.12',  // Cliente Individuo - Viajes en Cta Cte
  REP_19  = 'REP.19',  // Empresa - Tipos de Servicio & Centro Costos
  REP_11  = 'REP.11',  // Cliente Empresa - Centro de Costos y Colaboradores
  REP_18  = 'REP.18',  // Comisiones Configuradas
  REP_10  = 'REP.10',  // Comisiones Agencia
  REP_9   = 'REP.9',   // Transacciones con Tarjetas
  REP_8   = 'REP.8',   // Viajes por Segmentos
  REP_7   = 'REP.7',   // Ranking de Choferes
  REP_6   = 'REP.6',   // Ranking de Vehículos
  REP_5   = 'REP.5',   // Ranking de Clientes
  REP_4   = 'REP.4',   // Documentacion Vencida y Por Vencer
  REP_3   = 'REP.3',   // Resumen Diario
  REP_2   = 'REP.2',   // Viajes Impagos
  REP_1   = 'REP.1',   // Listado de Viajes
  REP_1_1 = 'REP.1.1', // Ver Totales

  AFI     = 'AFI',     // eAfiliados
  AFI_3   = 'AFI.3',   // Cuentas Corrientes
  AFI_2   = 'AFI.2',   // One-Shot Recibidos
  AFI_1   = 'AFI.1',   // One-Shot Solicitados
  AFI_S   = 'AFI.S',   // Solicitudes
  AFI_O   = 'AFI.O',   // Oferentes
  AFI_P   = 'AFI.P',   // Mi Perfil ATC

  GNET    = 'GNET',    // GNET
  GNET_C  = 'GNET.C',  // Cuentas Corrientes
  GNET_I  = 'GNET.I',  // Farm IN
  GNET_O  = 'GNET.O',  // Farm Out

  MAG     = 'MAG',     // MAGIIS Apps Store

  CFG     = 'CFG',     // Configuración
  CFG_U   = 'CFG.U',   // Perfiles de Usuarios
  CFG_C   = 'CFG.C',   // Perfiles de Acceso
  CFG_R   = 'CFG.R',   // Tarifadores
  CFG_PRECIOS = 'CFG.PRECIOS', // Precios Dinamicos
  CFG_A   = 'CFG.A',   // Areas
  CFG_Z   = 'CFG.Z',   // Zonas
  CFG_B   = 'CFG.B',   // Sucursales
  CFG_M   = 'CFG.M',   // Personalización de e-mails
  CFG_O   = 'CFG.O',   // Otros Costos
  CFG_X   = 'CFG.X',   // Impuestos y Cargos
  CFG_S   = 'CFG.S',   // Tipos de Servicios
  CFG_V   = 'CFG.V',   // Tipos de Vehículos
  CFG_P   = 'CFG.P',   // Preferencias Operativas

  XXX     = 'XXX',     // Acceso Directo
  MEL     = 'MEL',     // MELITA
  MYC     = 'MYC',     // Mi Compañía
  NOT     = 'NOT',     // Notificaciones
  MSG     = 'MSG',     // Chat Chofer
}